export const BRAND = {
  name: "PROGETTO HOSPITALITY",
  line1: "PROGETTO",
  line2: "HOSPITALITY",
  subtitle: "Consulenza · Aperture · Gestione · Crescita",
  claim: "Dal tuo immobile alla tua attività ricettiva.",
  logo: (process.env.REACT_APP_LOGO_URL || "").trim(),
  monogram: "/images/monogram.png",
};

const clean = (v) => (v || "").trim();

export const CONTACT = {
  email: clean(process.env.REACT_APP_CONTACT_EMAIL),
  whatsapp: clean(process.env.REACT_APP_WHATSAPP_NUMBER),
  phone: clean(process.env.REACT_APP_PHONE),
  whatsappMessage: "Ciao, vorrei informazioni su Progetto HOSPITALITY.",
};

export const whatsappDigits = CONTACT.whatsapp.replace(/\D/g, "");
export const whatsappLink = whatsappDigits
  ? `https://wa.me/${whatsappDigits}?text=${encodeURIComponent(CONTACT.whatsappMessage)}`
  : "";

export const SOCIAL = {
  instagram: clean(process.env.REACT_APP_INSTAGRAM_URL),
  facebook: clean(process.env.REACT_APP_FACEBOOK_URL),
  linkedin: clean(process.env.REACT_APP_LINKEDIN_URL),
};

export const NAV = [
  { label: "Home", href: "#home" },
  { label: "Nuove aperture", href: "#nuove-aperture" },
  { label: "Rilancio", href: "#rilancio" },
  { label: "Servizi", href: "#servizi" },
  { label: "Gestione assistita", href: "#gestione-assistita" },
  { label: "Business Plan", href: "#business-plan" },
  { label: "Contatti", href: "#contatti" },
];

export const HERO = {
  text: "Affianchiamo proprietari, host e gestori nella progettazione, apertura, organizzazione e crescita di strutture ricettive.",
  cta1: "HO UN IMMOBILE DA APRIRE",
  cta2: "HO GIÀ UNA STRUTTURA",
  imageAlt: "Villa di campagna italiana trasformata in boutique hotel al tramonto, con cipressi e muri in pietra",
};

export const SITUAZIONE_CARDS = [
  {
    label: "PARTO DA ZERO",
    title: "Hai un immobile e vuoi trasformarlo in una struttura ricettiva?",
    text: "Ti accompagniamo dalla valutazione dell'immobile fino all'apertura, costruendo insieme un progetto sostenibile, organizzato e pronto ad accogliere i primi ospiti.",
    button: "SCOPRI IL PERCORSO",
    href: "#nuove-aperture",
    image: "/images/casale.webp",
    alt: "Casale in pietra con piscina nella campagna italiana",
  },
  {
    label: "HO GIÀ UNA STRUTTURA",
    title: "La tua struttura potrebbe rendere di più?",
    text: "Analizziamo fatturato, occupazione, prezzi, OTA, costi e organizzazione per individuare le opportunità di crescita.",
    button: "ANALIZZA LA MIA STRUTTURA",
    href: "#rilancio",
    image: "/images/camera.webp",
    alt: "Camera di un boutique hotel con biancheria in lino e luce calda",
  },
];

export const SERVIZI = [
  { icon: "KeyRound", title: "NUOVE APERTURE", text: "Dall'immobile all'apertura della struttura." },
  { icon: "TrendingUp", title: "RILANCIO", text: "Interveniamo sulle strutture che non stanno raggiungendo il loro potenziale." },
  { icon: "LineChart", title: "REVENUE MANAGEMENT", text: "Prezzi, occupazione, stagionalità e redditività." },
  { icon: "Globe", title: "OTA", text: "Booking, Airbnb e altri canali di vendita." },
  { icon: "MonitorSmartphone", title: "GESTIONALI E TECNOLOGIA", text: "PMS, channel manager, booking engine, automazioni e strumenti digitali." },
  { icon: "Scale", title: "CONTROLLO DEI COSTI", text: "Personale, lavanderia, utenze, fornitori e costi operativi." },
  { icon: "Coffee", title: "COLAZIONE", text: "Organizzazione, fornitori, food cost e riduzione degli sprechi." },
  { icon: "Megaphone", title: "MARKETING", text: "Come aumentare le prenotazioni dirette e il profitto aziendale." },
];

export const PERCORSI = [
  {
    id: "nuove-aperture",
    kicker: "PERCORSO 1",
    title: "PROGETTO APERTURA",
    subtitle: "Per chi ha un immobile e vuole partire da zero.",
    image: "/images/casale.webp",
    alt: "Casale in pietra con piscina, esempio di immobile da trasformare in struttura ricettiva",
    items: [
      "analisi dell'immobile", "studio di fattibilità", "analisi della zona", "analisi della domanda",
      "analisi dei competitor", "previsione del fatturato", "business plan", "posizionamento",
      "definizione del concept", "organizzazione degli spazi", "indicazioni su arredi e servizi",
      "supporto nell'iter burocratico (con coordinamento con i professionisti competenti)",
      "coordinamento con i professionisti competenti", "scelta del gestionale", "scelta del channel manager",
      "configurazione OTA", "strategia tariffaria", "procedure operative", "preparazione all'apertura",
    ],
    button: "INIZIA IL MIO PROGETTO",
    prefill: { situazione: "Ho un immobile", obiettivi: ["Aprire"] },
  },
  {
    id: "rilancio",
    kicker: "PERCORSO 2",
    title: "PROGETTO RILANCIO",
    subtitle: "Per B&B, affittacamere, case vacanze e piccoli hotel già attivi.",
    image: "/images/colazione.webp",
    alt: "Tavolo della colazione apparecchiato in una corte in pietra",
    items: [
      "analisi del fatturato", "analisi dell'occupazione", "ADR", "RevPAR", "analisi dei prezzi",
      "analisi del calendario", "analisi Booking", "analisi Airbnb", "analisi delle commissioni",
      "analisi dei costi", "analisi del personale", "analisi della colazione", "food cost",
      "analisi dei fornitori", "controllo delle spese", "analisi delle recensioni",
      "strategia di miglioramento", "piano operativo",
    ],
    button: "FAI CRESCERE LA TUA STRUTTURA",
    prefill: { situazione: "Ho già una struttura", obiettivi: ["Aumentare il fatturato"] },
  },
];

export const CALCOLATORE = {
  eyebrow: "Calcolatore del potenziale",
  title: "Quanto potrebbe rendere la tua struttura?",
  intro: "Inserisci i dati della tua struttura e imposta gli obiettivi che ritieni realistici: il calcolatore stima il divario di fatturato di cui vale la pena parlare insieme.",
  oggiTitle: "La tua situazione oggi",
  obiettiviTitle: "I tuoi obiettivi",
  labels: {
    camere: "Numero camere",
    prezzo: "Prezzo medio a notte per camera (€)",
    occupazione: "Occupazione media annua (%)",
    occObiettivo: "Occupazione obiettivo (%)",
    prezzoObiettivo: "Prezzo medio obiettivo (€)",
    fattOggi: "Fatturato annuo stimato oggi",
    fattObiettivo: "Fatturato annuo stimato con i tuoi obiettivi",
    divario: "Divario annuo",
    alMese: "al mese",
    revpar: "RevPAR (ricavo per camera disponibile)",
    revparOggi: "oggi",
    revparObiettivo: "obiettivo",
  },
  noGap: "Imposta obiettivi superiori alla situazione attuale per vedere il divario.",
  disclaimer: "Stima indicativa basata esclusivamente sui dati inseriti. Non costituisce una previsione né una promessa di risultato.",
  button: "COLMIAMO IL DIVARIO",
};

export const GESTIONE = {
  title: "Non vuoi fare tutto da solo?",
  text: "Progetto HOSPITALITY può diventare il tuo partner operativo per accompagnarti nel tempo.",
  items: [
    "controllo periodico delle performance", "revenue management", "supporto OTA", "supporto gestionale",
    "analisi dei dati", "controllo dei costi", "supporto organizzativo", "strategie commerciali",
    "confronto periodico con il proprietario",
  ],
  button: "SCOPRI LA GESTIONE ASSISTITA",
  prefill: { obiettivi: ["Avere un supporto continuativo"] },
  image: "/images/reception.webp",
  alt: "Reception elegante di una struttura ricettiva con documenti e computer portatile",
};

export const METODO = [
  { n: "01", title: "ANALIZZIAMO", text: "Studiamo struttura, mercato, numeri e obiettivi." },
  { n: "02", title: "PROGETTIAMO", text: "Costruiamo una strategia concreta." },
  { n: "03", title: "IMPLEMENTIAMO", text: "Trasformiamo la strategia in procedure e strumenti." },
  { n: "04", title: "OTTIMIZZIAMO", text: "Misuriamo i risultati e interveniamo dove serve." },
];

export const STRUTTURE = {
  title: "Strutture che ci hanno scelto",
  intro: "Alcune delle strutture che hanno scelto il nostro affiancamento.",
  linkLabel: "Visita il sito →",
  items: [
    {
      name: "Casale Elisa Country Hotel",
      tipologia: "Casa per ferie",
      localita: "Marina di San Nicola, Ladispoli (RM)",
      text: "Antica residenza della famiglia Odescalchi, restaurata e trasformata in una villa di campagna immersa nel verde, a pochi passi dal mare e da Roma.",
      url: "https://www.casaleelisa.com/",
      image: "/images/clienti/casale-elisa-1.webp",
      alt: "Casale Elisa, casale in pietra con giardino a Marina di San Nicola, Ladispoli",
      testimonial: { quote: "", author: "", role: "" },
    },
    {
      name: "Palazzo Vittoria Heritage Collection",
      tipologia: "Dimora storica",
      localita: "Centro storico di Cerveteri (RM)",
      text: "Palazzo storico con affreschi restaurati e torre panoramica con vista sulla necropoli etrusca e sul mare Tirreno, per un soggiorno intimo ed esclusivo.",
      url: "https://hotelpalazzovittoria.com/",
      image: "/images/clienti/palazzo-vittoria-1.webp",
      alt: "Palazzo Vittoria, sala con affreschi storici restaurati a Cerveteri",
      testimonial: { quote: "", author: "", role: "" },
    },
  ],
};

export const PER_CHI = [
  { icon: "Home", label: "Proprietari di immobili" },
  { icon: "Sparkles", label: "Nuovi imprenditori" },
  { icon: "UserRound", label: "Host" },
  { icon: "Briefcase", label: "Investitori" },
  { icon: "BedDouble", label: "B&B" },
  { icon: "DoorOpen", label: "Affittacamere" },
  { icon: "TreePalm", label: "Case vacanza" },
  { icon: "Gem", label: "Boutique hotel" },
  { icon: "Building2", label: "Piccoli alberghi" },
];

export const STATEMENT = {
  kicker: "Non vendiamo solo consulenza.",
  big: "Ti aiutiamo a trasformare un'idea, un immobile o una struttura in un'attività ricettiva organizzata e sostenibile.",
  text: "Il nostro approccio è pratico. Analizziamo i problemi, individuiamo le opportunità e lavoriamo insieme per implementare soluzioni concrete.",
};

export const BUSINESS_PLAN = {
  title: "Prima dei numeri, analizziamo il progetto.",
  intro: "Per ogni nuova iniziativa è possibile sviluppare un business plan completo che comprende:",
  items: [
    "analisi di mercato", "analisi competitiva", "investimento iniziale", "costi di gestione",
    "previsione dei ricavi", "break-even", "marginalità", "ROI", "scenari economici", "piano operativo",
  ],
  button: "RICHIEDI UN BUSINESS PLAN",
  prefill: { obiettivi: ["Aprire"], messaggio: "Vorrei richiedere un business plan per il mio progetto." },
};

export const CHI_SIAMO = {
  eyebrow: "Chi siamo",
  title: "Persone che l'ospitalità la vivono ogni giorno.",
  p1: "Progetto HOSPITALITY è un'azienda fatta di persone che lavorano da anni nel settore dell'ospitalità. Il nostro team ha maturato un'esperienza diretta come direttori d'albergo e come proprietari di strutture ricettive: conosciamo da dentro le dinamiche quotidiane di una struttura, dalla gestione delle camere al rapporto con gli ospiti, dai costi operativi ai canali di vendita.",
  p2: "Per questo il nostro approccio è concreto. Non proponiamo teorie: portiamo nei progetti dei nostri clienti le soluzioni che abbiamo già sperimentato sul campo, adattandole alla realtà di ogni struttura, dal piccolo B&B al boutique hotel.",
  points: [
    "Esperienza diretta nella direzione d'albergo",
    "Esperienza come proprietari di strutture ricettive",
    "Affiancamento operativo, al fianco del proprietario",
  ],
  button: "Parliamo del tuo progetto",
  image: "/images/chi-siamo-2.webp",
  alt: "Consulente e proprietaria di un B&B analizzano i dati della struttura",
};

export const FORM_OPTIONS = {
  tipologie: ["Nuova apertura", "B&B", "Affittacamere", "Casa vacanze", "Boutique hotel", "Piccolo albergo", "Altro"],
  situazioni: ["Ho un immobile", "Ho già una struttura", "Sto valutando un investimento"],
  obiettivi: [
    "Aprire", "Aumentare il fatturato", "Ridurre i costi", "Migliorare la gestione",
    "Aumentare l'occupazione", "Migliorare Booking/Airbnb", "Avere un supporto continuativo",
  ],
};

export const FORM_TEXT = {
  title: "Raccontaci il tuo progetto",
  submit: "INVIA LA RICHIESTA",
  sending: "INVIO IN CORSO…",
  success: "Grazie. Abbiamo ricevuto la tua richiesta. Ti ricontatteremo per conoscere meglio il progetto.",
  error: "Si è verificato un errore durante l'invio. Riprova tra qualche istante oppure contattaci via email o WhatsApp.",
  privacy: "Ho letto l'informativa sulla privacy e acconsento al trattamento dei dati per essere ricontattato.",
};
